import { TextBox } from "devextreme-react";
import { useDispatch, useSelector } from "react-redux";
import { updateSubject } from "./Redux/workRecord";

export default function SubjectTextBox(props) {
  const {
    subjectTextBoxRef,
    // currentEmployeeNo
    currentEmployee,
  } = props;

  const subject = useSelector((state) => state.workRecord.subject);
  const classifWork = useSelector((state) => state.workRecord.classifWork);

  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.userInfo);

  const onValueChanged = (e) => {
    if (e.value && classifWork) {
      subjectTextBoxRef.current.instance.option("validationStatus", "valid");

      dispatch(
        updateSubject({
          subject: e.value,
        })
      );
    }
  };
  return (
    <TextBox
      ref={subjectTextBoxRef}
      // showClearButton={true}
      value={subject}
      // readOnly={userInfo.employeeNo == currentEmployeeNo ? false : true}
      readOnly={
        userInfo.employeeNo == currentEmployee.employeeNo ? false : true
      }
      onValueChanged={onValueChanged}
    ></TextBox>
  );
}
